import React from 'react';
import styled from 'styled-components';

const DateInputWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    width: 80%;
`;

const Input = styled.input`
    flex: 3;
    padding: 8px;
    margin-left: 10px;
`;

interface DateInputProps {
    value: string;
    placeholder: string;
    disabled?: boolean;
    onChange: (e: any) => void;
}

const CustomDateInput: React.FC<DateInputProps> = ({ placeholder, value, onChange, disabled }) => {
    return (
        <DateInputWrapper>
            <Input
                type="date"
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange(e)}
                style={{ opacity: disabled ? '0.5' : '1' }}
            />
        </DateInputWrapper>
    );
};

export default CustomDateInput;
